<ng-container *transloco="let t" class="container">
  <div class="d-flex flex-column justify-content-start align-items-start pt-xl-2 pb-xl-2">
    @if (label || translatedLabel) {
    <label>
      {{ translatedLabel ?? t(label!) }}
      @if (control.errors?.['required']) {
      <small>*</small>
      }
    </label>
    }
    <form [formGroup]="form">
      <div class="d-flex align-items-center">
        <div class="input-container">
          <input type="number" class="form-control" name="hours" formControlName="hours" placeholder="hh" [min]="0">
        </div>
        <div class="spacer">
          :
        </div>
        <div class="input-container">
          <input type="number" class="form-control" name="minutes" formControlName="minutes" placeholder="mm" [min]="0"
            [max]="60" (touchend)="control.markAsTouched()">
        </div>
        <div class="spacer">
          :
        </div>
        <div class="input-container">
          <input type="number" class="form-control" name="seconds" formControlName="seconds" placeholder="ss" [min]="0"
            [max]="60" (touchend)="control.markAsTouched()">
        </div>
      </div>
    </form>
    @if (control.touched) {
    @for(errorMessage of control.errors | errorMessages:formControlName; track errorMessage){
    <div class="errorMes pt-1">
      {{ errorMessage }}
    </div>
    }
    }
  </div>
</ng-container>